import { render, staticRenderFns } from "./leader-step.vue?vue&type=template&id=35ba8738&scoped=true"
import script from "./leader-step.vue?vue&type=script&lang=js"
export * from "./leader-step.vue?vue&type=script&lang=js"
import style0 from "./leader-step.vue?vue&type=style&index=0&id=35ba8738&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba8738",
  null
  
)

export default component.exports